'use client';

import { T } from '@/i18n/LocaleProvider';

export default function Eyebrow({ children, dark = false, className = '' }) {
  return (
    <span className={`eyebrow ${dark ? 'dark' : ''} ${className}`.trim()}>
      <T>{children}</T>
    </span>
  );
}
